<template>
  <v-container justify-center>
    <EditProfileForm />
  </v-container>
</template>

<script>
import EditProfileForm from '@/components/EditProfileForm'

export default {
  name: 'edit-profile',
  components: {
    EditProfileForm
  }
}
</script>
